module.exports = __webpack_public_path__ + "img/Elements_216x50.c46cef24.png";